// Firebase's client SDK prefixes callable HttpsError codes with "functions/".
// ** IMPORTANT **: Keep shared values in sync with emailConversionCallableErrorCode.tsx.
export enum FIREBASE_CALLABLE_ERROR_CODE {
    alreadyExists = 'functions/already-exists',
    unavailable = 'functions/unavailable',
    invalidArgument = 'functions/invalid-argument',
    failedPrecondition = 'functions/failed-precondition',
    notFound = 'functions/not-found',
    unauthenticated = 'functions/unauthenticated',
    permissionDenied = 'functions/permission-denied',
}
